import React from "react";

// Default components
import {defaultComponents} from "./../components/_default/interfaces/DefaultComponents"
import ContentRenderer from "./../components/_default/ContentRenderer"
import MetadataComponent from "./../components/_default/MetadataComponent";
import CheckNotFoundPage from "./../components/_default/CheckNotFoundPage";
import { useAppSelector, useAppDispatch } from "./../store/hooks"

window.defaultComponents = defaultComponents;

export default function Webpage462sundmus() {
        const page_seo = {
                    seo_title: 'sundmus - testprana.itpr.eu',
                    canonical: 'https:\/\/testprana.itpr.eu\/et\/sundmus',
            }
    
    const dispatch = useAppDispatch();
    
    React.useEffect(() => {
        dispatch({
            type: "SET_WEBPAGE_ACTIVE",
            payload: "019c89f4-e1d7-7bae-b5e3-7cdd3ecd3b30"
        });
    }, [])
    
    React.useEffect(() => {
        dispatch({
            type: "UPDATE_STRUCTURE",
            payload: {"webpageComponents":[11496],"components":{"11496":{"id":11496,"uuid":"019c7a2d-6524-75ae-9567-dd2fbb9a45ca","language_id":null,"parent_id":null,"webpage_id":462,"type":"section","sort_order":0,"version":1,"isShared":false,"attributes":{"classes":"row","content_width_unit":"px","content_width_size":800,"styles":{"paddingTop":"60px","paddingLeft":"60px","paddingRight":"60px","paddingBottom":"60px"}},"childWebpageComponentRelations":[{"id":10500,"parent_id":11496,"child_id":11497,"sort":1,"created_at":null,"updated_at":null}]},"11497":{"id":11497,"uuid":"019c7a2d-6524-75ae-9567-dd2fbc607cfd","language_id":2,"parent_id":11496,"webpage_id":462,"type":"section","sort_order":1,"version":1,"isShared":false,"attributes":{"classes":"col col-12","styles":{"paddingTop":"20px","paddingLeft":"10px","paddingBottom":"20px","paddingRight":"10px"}},"childWebpageComponentRelations":[{"id":10556,"parent_id":11497,"child_id":11559,"sort":1,"created_at":null,"updated_at":"2026-04-01T08:18:01.000000Z"}]},"11559":{"id":11559,"uuid":"019c7a2d-6525-7cca-8a1b-7b2b4231aad6","language_id":2,"parent_id":11497,"webpage_id":462,"type":"eventComponent","sort_order":1,"version":1,"isShared":false,"attributes":{"event_group_hash":"032hBws2vgBd6OgjUTcGFy","event_group_name":"Kardis\u00f5it","styles":[]},"childWebpageComponentRelations":[]}}}        });
    }, [])
    
    
    
    return (
        <>
            <CheckNotFoundPage/>
            <MetadataComponent page_seo={page_seo} />
            <ContentRenderer />
        </>
    );
}